import DigitalDataProvider from './DigitalDataProvider';
import DigitalDataTestProvider from './DigitalDataTestProvider';

// TEST FLAGS
const DD_DISABLE_SWATCH_HOVER = 'test.disableSwatchHover';
const DD_HYPERLINK_DESC = 'test.mfeHyperlinkDescriptor';
const DD_MODEL_IMAGERY_TEST = 'test.modelImageryTest';
const DD_SEARCH_FLYOUT_ALGONOMY_SUGGESTIONS_TEST = 'test.searchFlyoutAlgonomySuggestions';
const DD_DISCOVER_BY_FACET_TEST = 'test.discoverByFacet';

// FEATURE FLAGS
const DD_TIK_TOK_FOOTER_ICON_FLAG = 'flag.tik-tok-footer-icon';
const DD_USER_PREFERENCE_TOASTER_FLAG = 'flag.user-preference-bob-toaster';
const DD_HAS_ALGONOMY_REFETCH_ON_CONSENT_INTERACTION_ENABLED = 'flag.has-algonomy-refetch-on-consent-interaction-enabled';

export {
  DigitalDataTestProvider,
  DD_DISABLE_SWATCH_HOVER,
  DD_DISCOVER_BY_FACET_TEST,
  DD_HAS_ALGONOMY_REFETCH_ON_CONSENT_INTERACTION_ENABLED,
  DD_HYPERLINK_DESC,
  DD_MODEL_IMAGERY_TEST,
  DD_TIK_TOK_FOOTER_ICON_FLAG,
  DD_USER_PREFERENCE_TOASTER_FLAG,
  DD_SEARCH_FLYOUT_ALGONOMY_SUGGESTIONS_TEST,
};

export default DigitalDataProvider;
